import React from "react";
import toastMessage from "../../../utils/toastMessage";
import { fetchPackagingData } from "../../../utils/queries/packagingQuery";
import { getBloodtestById } from "../../../utils/queries/bloodTest/bloodTestQuery";
import { Table } from "../../Table";
import language from "../../../language";
import { connect } from "react-redux";
import { Button } from "../../Button";
import api from "../../../utils/api";
import { Modal } from "../../Modal";
import { Input } from "../../Input";

class SampleReception extends React.Component {
  state = {
    packaging: [],
    isLoading: true,
    pendingPackages: [],
    coolerBox: [],
    isSubmitting: false,
    error: {},
    transportationTemperature: "",
    show: false,
  };

  componentDidMount() {
    this.getPackaging();
  }

  getTestInfo = async () => {
    const data = await getBloodtestById(this.props.testId);
    return data;
  };

  getPackaging = async () => {
    try {
      this.setState({ isLoading: true });

      let { pendingPackages, coolerBox } = this.state;

      const testingInfo = await this.getTestInfo();

      if (!testingInfo && !testingInfo?.donation?._id) {
        return toastMessage("error", "Donation not found");
      }

      const data = await fetchPackagingData(this.props.defaultLanguage, {
        donation: testingInfo?.donation?._id,
        "coolerBox.types": ["SAMPLE"],
      });
      this.setState({ packaging: data, isLoading: false });

      for (let el of data) {
        console.log(el.status);
        if (
          el.status?.toUpperCase() === "TRANSFERRED" &&
          !pendingPackages?.includes(el?._id)
        ) {
          pendingPackages.push(el._id);
          coolerBox.push({
            id: el.coolerBox?._id || el.coolerBox,
            packageId: el._id,
          });
        }
      }

      this.setState({ pendingPackages });
    } catch (error) {
      this.setState({ isLoading: false });
      toastMessage("error", error);
    }
  };

  returnTableHeaders = () => {
    return [
      {
        title: language[this.props.defaultLanguage].sample,
        key: "sample",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].cooler_box,
        key: "code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
    ];
  };

  validateForm = () => {
    let { error, transportationTemperature } = this.state;

    if (transportationTemperature === "") {
      error.transportationTemperature =
        "Transportation temperature is required";
    }
    console.log(error);
    this.setState({ error });
  };

  onReceive = async () => {
    try {
      await this.validateForm();

      const { error, coolerBox } = this.state;

      if (Object.keys(error).length > 0) return;

      this.setState({ isSubmitting: true });

      for (let elCool of coolerBox) {
        const options = {
          method: "PUT",
          url: `${process.env.REACT_APP_BBMS_BASE_API}/packaging`,
          data: {
            status: "received",
            coolerBox: elCool.id,
            id: elCool.packageId,
            transportationTemperature: this.state.transportationTemperature,
          },
          headers: {
            Authorization: `Bearer ${this.props.token}`,
          },
        };

        await api(options);

        toastMessage("success", `Donation has been received successfully`);

        this.setState({ isSubmitting: false, show: false }, () => {
          this.getPackaging();
        });
      }
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isSubmitting: false });
    }
  };

  handleShowModal = () => {
    this.setState({
      show: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      show: false,
    });
  };

  onChangeText = (field, e) => {
    this.setState({
      error: {},
      [field]: e.target.value,
    });
  };

  render() {
    return (
      <div>
        {this.state.pendingPackages.length > 0 && (
          <Button
            onPress={this.handleShowModal.bind(this)}
            text={`Receive (${this.state.pendingPackages.length}) samples`}
          />
        )}
        <Table
          data={this.state.packaging}
          headers={this.returnTableHeaders()}
          isLoading={this.state.isLoading}
        />

        <Modal
          show={this.state.show}
          onClose={this.handleCloseModal.bind(this)}
        >
          <div className="modal-body">
            <div className="col-md-12">
              <Input
                placeholder={language[this.props.defaultLanguage].enter_number}
                label={
                  language[this.props.defaultLanguage]
                    .transportation_temperature
                }
                required
                value={this.state.transportationTemperature}
                onChange={(e) =>
                  this.onChangeText("transportationTemperature", e)
                }
                error={this.state.error.transportationTemperature}
                type="number"
                max={30}
              />
            </div>
          </div>
          <div className="modal-footer">
            <Button
              onPress={this.handleCloseModal.bind(this)}
              text={language[this.props.defaultLanguage].cancel}
              className="btn-default"
            />
            <Button
              onPress={this.onReceive.bind(this)}
              text={language[this.props.defaultLanguage].submit}
              isSubmitting={this.state.isSubmitting}
            />
          </div>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(SampleReception);
